/**
 * Generated by orval 🍺
 * Do not edit manually.
 * api API
 * OpenAPI spec version: 1.0
 */
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { BulkLookup200 } from "../models/bulkLookup200";

import type { BulkLookupRequest } from "../models/bulkLookupRequest";

import type { LookupByKeysRequest } from "../models/lookupByKeysRequest";

import type { LookupRequest } from "../models/lookupRequest";

import type { LookupResponse } from "../models/lookupResponse";

import type { SourceEnvLookupParams } from "../models/sourceEnvLookupParams";

import { executeFetch } from "../../utils/fetch/fetch";
import type { ErrorType } from "../../utils/fetch/fetch";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Lookup
 */
export const lookup = (
  lookupRequest: LookupRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<LookupResponse>(
    {
      url: `/api/lookup`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: lookupRequest,
      signal,
    },
    options,
  );
};

export const getLookupInfiniteQueryKey = (lookupRequest?: LookupRequest) => {
  return ["infinite", `/api/lookup`, lookupRequest] as const;
};

export const getLookupQueryKey = (lookupRequest?: LookupRequest) => {
  return [`/api/lookup`, lookupRequest] as const;
};

export const getLookupInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof lookup>>>,
  TError = ErrorType<unknown>,
>(
  lookupRequest: LookupRequest,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof lookup>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLookupInfiniteQueryKey(lookupRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof lookup>>> = ({
    signal,
    meta,
  }) => lookup(lookupRequest, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof lookup>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LookupInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookup>>
>;
export type LookupInfiniteQueryError = ErrorType<unknown>;

export function useLookupInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof lookup>>>,
  TError = ErrorType<unknown>,
>(
  lookupRequest: LookupRequest,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof lookup>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookup>>,
          TError,
          Awaited<ReturnType<typeof lookup>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof lookup>>>,
  TError = ErrorType<unknown>,
>(
  lookupRequest: LookupRequest,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof lookup>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookup>>,
          TError,
          Awaited<ReturnType<typeof lookup>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof lookup>>>,
  TError = ErrorType<unknown>,
>(
  lookupRequest: LookupRequest,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof lookup>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lookup
 */

export function useLookupInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof lookup>>>,
  TError = ErrorType<unknown>,
>(
  lookupRequest: LookupRequest,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof lookup>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getLookupInfiniteQueryOptions(lookupRequest, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lookup
 */
export const prefetchLookupInfinite = async <
  TData = Awaited<ReturnType<typeof lookup>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  lookupRequest: LookupRequest,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof lookup>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getLookupInfiniteQueryOptions(lookupRequest, options);

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
};

export const getLookupQueryOptions = <
  TData = Awaited<ReturnType<typeof lookup>>,
  TError = ErrorType<unknown>,
>(
  lookupRequest: LookupRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof lookup>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLookupQueryKey(lookupRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof lookup>>> = ({
    signal,
    meta,
  }) => lookup(lookupRequest, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof lookup>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LookupQueryResult = NonNullable<Awaited<ReturnType<typeof lookup>>>;
export type LookupQueryError = ErrorType<unknown>;

export function useLookup<
  TData = Awaited<ReturnType<typeof lookup>>,
  TError = ErrorType<unknown>,
>(
  lookupRequest: LookupRequest,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof lookup>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookup>>,
          TError,
          Awaited<ReturnType<typeof lookup>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookup<
  TData = Awaited<ReturnType<typeof lookup>>,
  TError = ErrorType<unknown>,
>(
  lookupRequest: LookupRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof lookup>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookup>>,
          TError,
          Awaited<ReturnType<typeof lookup>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookup<
  TData = Awaited<ReturnType<typeof lookup>>,
  TError = ErrorType<unknown>,
>(
  lookupRequest: LookupRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof lookup>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lookup
 */

export function useLookup<
  TData = Awaited<ReturnType<typeof lookup>>,
  TError = ErrorType<unknown>,
>(
  lookupRequest: LookupRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof lookup>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getLookupQueryOptions(lookupRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lookup
 */
export const prefetchLookup = async <
  TData = Awaited<ReturnType<typeof lookup>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  lookupRequest: LookupRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof lookup>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getLookupQueryOptions(lookupRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Bulk Lookup
 */
export const bulkLookup = (
  bulkLookupRequest: BulkLookupRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<BulkLookup200>(
    {
      url: `/api/lookup/bulk`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bulkLookupRequest,
      signal,
    },
    options,
  );
};

export const getBulkLookupQueryKey = (
  bulkLookupRequest?: BulkLookupRequest,
) => {
  return [`/api/lookup/bulk`, bulkLookupRequest] as const;
};

export const getBulkLookupQueryOptions = <
  TData = Awaited<ReturnType<typeof bulkLookup>>,
  TError = ErrorType<unknown>,
>(
  bulkLookupRequest: BulkLookupRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof bulkLookup>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBulkLookupQueryKey(bulkLookupRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof bulkLookup>>> = ({
    signal,
    meta,
  }) => bulkLookup(bulkLookupRequest, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof bulkLookup>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BulkLookupQueryResult = NonNullable<
  Awaited<ReturnType<typeof bulkLookup>>
>;
export type BulkLookupQueryError = ErrorType<unknown>;

export function useBulkLookup<
  TData = Awaited<ReturnType<typeof bulkLookup>>,
  TError = ErrorType<unknown>,
>(
  bulkLookupRequest: BulkLookupRequest,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof bulkLookup>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof bulkLookup>>,
          TError,
          Awaited<ReturnType<typeof bulkLookup>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBulkLookup<
  TData = Awaited<ReturnType<typeof bulkLookup>>,
  TError = ErrorType<unknown>,
>(
  bulkLookupRequest: BulkLookupRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof bulkLookup>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof bulkLookup>>,
          TError,
          Awaited<ReturnType<typeof bulkLookup>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBulkLookup<
  TData = Awaited<ReturnType<typeof bulkLookup>>,
  TError = ErrorType<unknown>,
>(
  bulkLookupRequest: BulkLookupRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof bulkLookup>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Bulk Lookup
 */

export function useBulkLookup<
  TData = Awaited<ReturnType<typeof bulkLookup>>,
  TError = ErrorType<unknown>,
>(
  bulkLookupRequest: BulkLookupRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof bulkLookup>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBulkLookupQueryOptions(bulkLookupRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Bulk Lookup
 */
export const prefetchBulkLookup = async <
  TData = Awaited<ReturnType<typeof bulkLookup>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  bulkLookupRequest: BulkLookupRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof bulkLookup>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getBulkLookupQueryOptions(bulkLookupRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Lookup By Key
 */
export const lookupSingleKey = (
  lookupByKeysRequest: LookupByKeysRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<unknown>(
    {
      url: `/api/lookup/single-key`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: lookupByKeysRequest,
      signal,
    },
    options,
  );
};

export const getLookupSingleKeyQueryKey = (
  lookupByKeysRequest?: LookupByKeysRequest,
) => {
  return [`/api/lookup/single-key`, lookupByKeysRequest] as const;
};

export const getLookupSingleKeyQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupSingleKey>>,
  TError = ErrorType<unknown>,
>(
  lookupByKeysRequest: LookupByKeysRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupSingleKey>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLookupSingleKeyQueryKey(lookupByKeysRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof lookupSingleKey>>> = ({
    signal,
    meta,
  }) =>
    lookupSingleKey(lookupByKeysRequest, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof lookupSingleKey>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LookupSingleKeyQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupSingleKey>>
>;
export type LookupSingleKeyQueryError = ErrorType<unknown>;

export function useLookupSingleKey<
  TData = Awaited<ReturnType<typeof lookupSingleKey>>,
  TError = ErrorType<unknown>,
>(
  lookupByKeysRequest: LookupByKeysRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupSingleKey>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupSingleKey>>,
          TError,
          Awaited<ReturnType<typeof lookupSingleKey>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupSingleKey<
  TData = Awaited<ReturnType<typeof lookupSingleKey>>,
  TError = ErrorType<unknown>,
>(
  lookupByKeysRequest: LookupByKeysRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupSingleKey>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lookupSingleKey>>,
          TError,
          Awaited<ReturnType<typeof lookupSingleKey>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLookupSingleKey<
  TData = Awaited<ReturnType<typeof lookupSingleKey>>,
  TError = ErrorType<unknown>,
>(
  lookupByKeysRequest: LookupByKeysRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupSingleKey>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Lookup By Key
 */

export function useLookupSingleKey<
  TData = Awaited<ReturnType<typeof lookupSingleKey>>,
  TError = ErrorType<unknown>,
>(
  lookupByKeysRequest: LookupByKeysRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupSingleKey>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getLookupSingleKeyQueryOptions(
    lookupByKeysRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lookup By Key
 */
export const prefetchLookupSingleKey = async <
  TData = Awaited<ReturnType<typeof lookupSingleKey>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  lookupByKeysRequest: LookupByKeysRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof lookupSingleKey>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getLookupSingleKeyQueryOptions(
    lookupByKeysRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Source Env Lookup
 */
export const sourceEnvLookup = (
  lookupRequest: LookupRequest,
  params?: SourceEnvLookupParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<LookupResponse>(
    {
      url: `/api/lookup/source-env`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: lookupRequest,
      params,
      signal,
    },
    options,
  );
};

export const getSourceEnvLookupInfiniteQueryKey = (
  lookupRequest?: LookupRequest,
  params?: SourceEnvLookupParams,
) => {
  return [
    "infinite",
    `/api/lookup/source-env`,
    ...(params ? [params] : []),
    lookupRequest,
  ] as const;
};

export const getSourceEnvLookupQueryKey = (
  lookupRequest?: LookupRequest,
  params?: SourceEnvLookupParams,
) => {
  return [
    `/api/lookup/source-env`,
    ...(params ? [params] : []),
    lookupRequest,
  ] as const;
};

export const getSourceEnvLookupInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof sourceEnvLookup>>>,
  TError = ErrorType<unknown>,
>(
  lookupRequest: LookupRequest,
  params?: SourceEnvLookupParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof sourceEnvLookup>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSourceEnvLookupInfiniteQueryKey(lookupRequest, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sourceEnvLookup>>> = ({
    signal,
    meta,
  }) =>
    sourceEnvLookup(lookupRequest, params, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof sourceEnvLookup>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SourceEnvLookupInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof sourceEnvLookup>>
>;
export type SourceEnvLookupInfiniteQueryError = ErrorType<unknown>;

export function useSourceEnvLookupInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof sourceEnvLookup>>>,
  TError = ErrorType<unknown>,
>(
  lookupRequest: LookupRequest,
  params: undefined | SourceEnvLookupParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof sourceEnvLookup>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sourceEnvLookup>>,
          TError,
          Awaited<ReturnType<typeof sourceEnvLookup>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSourceEnvLookupInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof sourceEnvLookup>>>,
  TError = ErrorType<unknown>,
>(
  lookupRequest: LookupRequest,
  params?: SourceEnvLookupParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof sourceEnvLookup>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sourceEnvLookup>>,
          TError,
          Awaited<ReturnType<typeof sourceEnvLookup>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSourceEnvLookupInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof sourceEnvLookup>>>,
  TError = ErrorType<unknown>,
>(
  lookupRequest: LookupRequest,
  params?: SourceEnvLookupParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof sourceEnvLookup>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Source Env Lookup
 */

export function useSourceEnvLookupInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof sourceEnvLookup>>>,
  TError = ErrorType<unknown>,
>(
  lookupRequest: LookupRequest,
  params?: SourceEnvLookupParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof sourceEnvLookup>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSourceEnvLookupInfiniteQueryOptions(
    lookupRequest,
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Source Env Lookup
 */
export const prefetchSourceEnvLookupInfinite = async <
  TData = Awaited<ReturnType<typeof sourceEnvLookup>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  lookupRequest: LookupRequest,
  params?: SourceEnvLookupParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof sourceEnvLookup>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getSourceEnvLookupInfiniteQueryOptions(
    lookupRequest,
    params,
    options,
  );

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
};

export const getSourceEnvLookupQueryOptions = <
  TData = Awaited<ReturnType<typeof sourceEnvLookup>>,
  TError = ErrorType<unknown>,
>(
  lookupRequest: LookupRequest,
  params?: SourceEnvLookupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sourceEnvLookup>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSourceEnvLookupQueryKey(lookupRequest, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sourceEnvLookup>>> = ({
    signal,
    meta,
  }) =>
    sourceEnvLookup(lookupRequest, params, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof sourceEnvLookup>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SourceEnvLookupQueryResult = NonNullable<
  Awaited<ReturnType<typeof sourceEnvLookup>>
>;
export type SourceEnvLookupQueryError = ErrorType<unknown>;

export function useSourceEnvLookup<
  TData = Awaited<ReturnType<typeof sourceEnvLookup>>,
  TError = ErrorType<unknown>,
>(
  lookupRequest: LookupRequest,
  params: undefined | SourceEnvLookupParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sourceEnvLookup>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sourceEnvLookup>>,
          TError,
          Awaited<ReturnType<typeof sourceEnvLookup>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSourceEnvLookup<
  TData = Awaited<ReturnType<typeof sourceEnvLookup>>,
  TError = ErrorType<unknown>,
>(
  lookupRequest: LookupRequest,
  params?: SourceEnvLookupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sourceEnvLookup>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sourceEnvLookup>>,
          TError,
          Awaited<ReturnType<typeof sourceEnvLookup>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSourceEnvLookup<
  TData = Awaited<ReturnType<typeof sourceEnvLookup>>,
  TError = ErrorType<unknown>,
>(
  lookupRequest: LookupRequest,
  params?: SourceEnvLookupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sourceEnvLookup>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Source Env Lookup
 */

export function useSourceEnvLookup<
  TData = Awaited<ReturnType<typeof sourceEnvLookup>>,
  TError = ErrorType<unknown>,
>(
  lookupRequest: LookupRequest,
  params?: SourceEnvLookupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sourceEnvLookup>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSourceEnvLookupQueryOptions(
    lookupRequest,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Source Env Lookup
 */
export const prefetchSourceEnvLookup = async <
  TData = Awaited<ReturnType<typeof sourceEnvLookup>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  lookupRequest: LookupRequest,
  params?: SourceEnvLookupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sourceEnvLookup>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getSourceEnvLookupQueryOptions(
    lookupRequest,
    params,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};
